import React, { ReactElement } from 'react';

import { RectanglePercentInterface, LayoutState } from "../../../store/layouts/types";
import TitleCameraComponent from "../../reusable/TitleCameraComponent";
import CameraListContainer from "../../../containers/CameraListContainer";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface Props {
  positions: RectanglePercentInterface[],
  checkedPane: null | number,
  expandedVideoLayout: number | null,
  handler: (e: React.MouseEvent, i: number) => void,
  children: ReactElement
}

const styleExpanded = {
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  zIndex: 2
};


const LiveLayoutComponent: React.FC<Props> = ({positions, checkedPane, expandedVideoLayout, handler, children}) => {
  const {initialCameras} = useSelector<ApplicationState, LayoutState>(state => state.layouts);

  const layoutElements = positions
    ? positions.map((styleDefault: RectanglePercentInterface, i: number) => {
      const classValue = i === checkedPane ? 'layout-item checked' : 'layout-item';
      const style = expandedVideoLayout === i ? styleExpanded : styleDefault;
      const cameraName = initialCameras[i] ? initialCameras[i].name : null;
      const activeClassName = () => {
        const cam = initialCameras?.[i];
        if (!cam) return `camera`;
        switch (cam.type) {
          case 'Map':
            return `map`;
          case 'WebPage':
            return `webPage`;
          default:
            return `camera`;
        }
      }

      return (
        <div className={`${classValue} ${activeClassName()}`} style={style}
             key={i}
        >
          <div className='pos-rel w-100 h-100'>
            <div className='pos-rel w-100 h-100'
                 onClick={(e) => handler(e, i)}>
              <TitleCameraComponent pane={i}
                                    cameraName={cameraName}
              />
              {React.cloneElement(children, {pane: i})}
            </div>
            {checkedPane === i ? <CameraListContainer pane={i}/> : null}
          </div>
        </div>
      )
    })
    : 'Needed to be checked layout';

  return (
    <div className='pos-rel w-100 h-100'>
      {layoutElements}
    </div>
  )
};

export default LiveLayoutComponent